var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark-icon_svg__a)",
    d: "M7.83 4.53L3.63.33a1.3 1.3 0 00-.8-.33H.67A.67.67 0 000 .67v2.16c.01.3.13.58.34.8l4.19 4.2a.56.56 0 00.4.17.5.5 0 00.35-.15.53.53 0 00.14-.25l.48-1.59a.17.17 0 01.11-.1l1.6-.5a.51.51 0 00.21-.88zM2 2.5a.5.5 0 110-1 .5.5 0 010 1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bookmark-icon_svg__a",
    x1: 5,
    x2: 11.78,
    y1: 11.28,
    y2: 2.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5454D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8585FF"
  })))));
}

export default SvgBookmarkIcon;